import { render } from "./openApp.vue?vue&type=template&id=8b700eec"
import script from "./openApp.vue?vue&type=script&lang=js"
export * from "./openApp.vue?vue&type=script&lang=js"

import "./openApp.vue?vue&type=style&index=0&id=8b700eec&lang=scss"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__